<template>
  <div class="reputation d-flex align-items-center">
    <i
      v-for="(icon, index) in getReputationIcons()"
      :key="index"
      :class="icon"
    />
    <span class="comments">
      &nbsp;({{ reviews }} <i class="fa-regular fa-comment" />)
    </span>
  </div>
</template>

<script>
export default {
  name: 'ReputationIcons',

  props: {
    score: {
      type: Number,
      required: true,
    },
    reviews: {
      type: Number,
      required: true,
    },
  },
  methods: {
    getReputationIcons() {
      const iconsArray = [];
      const int = Math.trunc(this.score);
      for (let i = 0; i < int; i++) {
        iconsArray.push('icon-star');
      }

      const dec = this.score - int;

      if (dec >= 0.3 && dec <= 0.7) {
        iconsArray.push('icon-star-half-alt');
      } else if (dec > 0.7) {
        iconsArray.push('icon-star');
      }

      for (let i = iconsArray.length; i < 5; i++) {
        iconsArray.push('icon-star-empty');
      }

      return iconsArray;
    },
  },
};
</script>

<style scoped>

.reputation i, .reputation i:before{
  font-size: 1.2rem!important;
  margin: 0;
  text-align: left;
  color: gold ;
  line-height: 1;
}

.reputation span{
  font-weight: 500;
  color: #999;
  font-size: .8rem;
}

.comments i, .comments i:before{
  font-size: .9rem!important;
  margin: 0;
  text-align: left;
  color: #999 ;
}

</style>
